// extracted by mini-css-extract-plugin
export default {"themeSwitcher":"ThemeSwitcher_themeSwitcher__01YWJ","switchRoot":"ThemeSwitcher_switchRoot__211ve","switchThumb":"ThemeSwitcher_switchThumb__Ibm8Q"};